import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgModule } from '@angular/core';
import { EditarCodigoReutilizableComponent } from './editar-codigo-reutilizable.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { EditarCodigoReutilizableRouting } from './editar-codigo-reutilizable-routing.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}


@NgModule({
  declarations: [EditarCodigoReutilizableComponent],
  imports: [
    EditarCodigoReutilizableRouting,
    SharedModule,
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true
    })
  ],
  entryComponents: []
})

export class EditarCodigoReutilizableModule { }
